<template>
  <div v-if="hasFieldsValue">
    <sc-text tag="h3" class="title" v-if="!isPerksPage" :field="fields.imageTitle"/>
    <div class="image">
      <custom-image class="img" :media="fields.image" size="cloudinary_body_image_url_large"/>
    </div>
    <sc-text aria-hidden="true" class="description" :class="{'description--dark': isPerksPage}" :field="fields.imageCaption"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Text } from '@sitecore-jss/sitecore-jss-vue'
import get from '~/helpers/get'
import CustomImage from '../custom-image'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')


export default {
  name: 'ImageBlock',

  props: {
    fields: {
      type: Object,
      default: () => ({})
    },

    isPerksPage: {
      type: Boolean,
      default: false
    }
  },

  components: {
    CustomImage,
    scText: Text
  },

  computed: {
    ...mapJssGetters(['isEditMode']),

    hasFieldsValue () {
      return (this.isEditMode
        || get(this.fields, ['image', 'value', 'src']))
        || get(this.fields, ['imageTitle', 'value'])
        || get(this.fields, ['imageCaption', 'value'])
    }
  }
}
</script>

<style lang="scss" scoped>

.image {
  ::v-deep img {
    padding: 0;
    margin-bottom: $d-base;
    width: 100%;
    height: auto;
  }
}

.title {
  @include font('030');

  margin-bottom: $d-base;
  letter-spacing: 0;
}

.description {
  @include font('030');

  display: block;
  margin-bottom: $space-080;
  letter-spacing: 0;

  @include tablet {
    margin-bottom: $space-090;
  }

  &--dark {
    color: $color-slate-dark;
  }
}
</style>
